import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { functions } from "../../constants/common-functions";

/* =====================================================
   MODAL
   ===================================================== */

function Modal(props) {
  return (
    <div style={styles.modalOverlay} onClick={props.onClose}>
      <div
        style={styles.modalBody}
        onClick={function (e) {
          e.stopPropagation();
        }}
      >
        <div style={styles.modalClose} onClick={props.onClose}>
          ✕
        </div>
        {props.children}
      </div>
    </div>
  );
}

/* =====================================================
   LEFT TREE NODE
   ===================================================== */

function DirectoryNode(props) {

  var node = props.node;
  var level = props.level;
  var selectedId = props.selectedId;
  var onSelect = props.onSelect;

  var isActive = selectedId === node.id;

  function handleClick() {

    if (isActive && node.expanded) {
      node.expanded = false;
      onSelect({ ...node });
      return;
    }

    onSelect(node);
  }

  return (
    <div style={{ position: "relative" }}>

      <div style={styles.treeVertical(level)} />

      <div
        style={{
          ...styles.directoryRow,
          paddingLeft: 36 + level * 16,
          ...(isActive ? styles.directoryNodeActive : {})
        }}
        onClick={handleClick}
      >
        <div style={styles.treeHorizontal(level)} />
        {node.expanded ? "📂" : "📁"} {node.name}
      </div>

      {node.expanded && node.children && node.children.map(function (child) {
        return (
          <DirectoryNode
            key={child.id}
            node={child}
            level={level + 1}
            selectedId={selectedId}
            onSelect={onSelect}
          />
        );
      })}
    </div>
  );
}

/* =====================================================
   EXPLORER
   ===================================================== */

function SharePointExplorer() {

  const [tree, setTree] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [contentItems, setContentItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalUrl, setModalUrl] = useState(null);

  useEffect(function () {

    setLoading(true);

    functions.getArrayFromAjax(
      "/resolutionsoftwareplatform/api/sharepoint/root",
      null,
      function (items) {

        var folders = items
          .filter(function (i) { return i.folder; })
          .map(function (i) {
            return {
              id: i.id,
              name: i.name,
              children: null,
              expanded: false
            };
          });

        setTree(folders);
        setContentItems(items);
        setSelectedFolder({ id: "root", name: "Root" });
        setLoading(false);
      }
    );

  }, []);

  function loadFolder(folder) {

    if (!folder || !folder.id) {
      return;
    }

    folder.expanded = true;
    setSelectedFolder(folder);
    setLoading(true);

    var url =
      folder.id === "root"
        ? "/resolutionsoftwareplatform/api/sharepoint/root"
        : "/resolutionsoftwareplatform/api/sharepoint/folder/" + folder.id;

    functions.getArrayFromAjax(
      url,
      null,
      function (items) {

        setContentItems(items);

        if (folder.children === null) {

          folder.children = items
            .filter(function (i) { return i.folder; })
            .map(function (i) {
              return {
                id: i.id,
                name: i.name,
                children: null,
                expanded: false
              };
            });

          setTree([].concat(tree));
        }

        setLoading(false);
      }
    );
  }

  /* =====================================================
     FILE OPEN LOGIC (MODAL)
     ===================================================== */

	 function openFile(file)
	 {
	     functions.getBlobFromAjax(
	         "/resolutionsoftwareplatform/api/sharepoint/file/" + file.id,
	         function(blob)
	         {
	             const url = window.URL.createObjectURL(blob);

	             window.open(url, "_blank");
	         }
	     );
	 }


  function renderTree() {
    return (
      <div style={styles.treePanel}>
        <div style={styles.panelHeader}>Directories</div>
        {tree.map(function (dir) {
          return (
            <DirectoryNode
              key={dir.id}
              node={dir}
              level={0}
              selectedId={selectedFolder ? selectedFolder.id : null}
              onSelect={loadFolder}
            />
          );
        })}
      </div>
    );
  }

  function renderContent() {

    if (loading) {
      return <div style={styles.emptyState}>Loading...</div>;
    }

    return (
      <div style={styles.contentPanel}>
        <div style={styles.panelHeader}>
          {selectedFolder ? selectedFolder.name : ""}
        </div>

        <div style={styles.sectionHeader}>Folders</div>
        {contentItems.filter(function (i) {
          return i.folder;
        }).map(function (dir) {
          return (
            <div
              key={dir.id}
              style={styles.itemRow}
              onClick={function () {
                loadFolder({
                  id: dir.id,
                  name: dir.name,
                  children: null,
                  expanded: false
                });
              }}
            >
              📁 {dir.name}
            </div>
          );
        })}

        <div style={styles.sectionHeader}>Files</div>
        {contentItems.filter(function (i) {
          return i.file;
        }).map(function (file) {
          return (
            <div
              key={file.id}
              style={styles.itemRow}
              onClick={function () {
                openFile(file);
              }}
            >
              📄 {file.name}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div style={styles.explorerContainer}>
      {renderTree()}
      {renderContent()}

	  {modalOpen && (
	    <Modal onClose={() => setModalOpen(false)}>
	      <iframe
	        src={modalUrl}
	        style={{ width: "100%", height: "100%", border: "none" }}
	        title="SharePoint Preview"
	      />
	    </Modal>
	  )}

    </div>
  );
}

/* =====================================================
   PAGE
   ===================================================== */

export default function SharePoint() {
  return (
    <div>
      <Header />
      <LeftMenu />
      <div style={styles.pageContainer}>
        <SharePointExplorer />
      </div>
    </div>
  );
}

/* =====================================================
   STYLES
   ===================================================== */

const styles = {

  pageContainer: {
    marginLeft: "60px",
    marginTop: "60px",
    width: "calc(100vw - 60px)"
  },

  explorerContainer: {
    display: "flex",
    height: "calc(100vh - 60px)",
    background: "#f4f6f9",
    overflow: "hidden",
    width: "100%"
  },

  treePanel: {
    width: "280px",
    background: "#ffffff",
    borderRight: "1px solid #ddd",
    overflowY: "auto"
  },

  contentPanel: {
    flex: 1,
    background: "#fafafa",
    padding: "16px",
    overflowY: "auto"
  },

  panelHeader: {
    padding: "12px 16px",
    fontWeight: "bold",
    borderBottom: "1px solid #ddd",
    background: "#fff"
  },

  directoryRow: {
    position: "relative",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
    zIndex: 2
  },

  directoryNodeActive: {
    background: "#0078d4",
    color: "#fff"
  },

  treeVertical: function (level) {
    return {
      position: "absolute",
      left: 16 + level * 16,
      top: 0,
      bottom: 0,
      width: "1px",
      background: "#ddd",
      zIndex: 1
    };
  },

  treeHorizontal: function (level) {
    return {
      position: "absolute",
      left: 16 + level * 16,
      top: "50%",
      width: "12px",
      height: "1px",
      background: "#ddd",
      zIndex: 3
    };
  },

  sectionHeader: {
    marginTop: "16px",
    marginBottom: "6px",
    fontSize: "13px",
    fontWeight: "bold",
    color: "#666"
  },

  itemRow: {
    padding: "10px",
    background: "#fff",
    borderRadius: "6px",
    marginBottom: "6px",
    cursor: "pointer"
  },

  emptyState: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#888"
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.6)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  modalBody: {
    width: "85%",
    height: "85%",
    background: "#fff",
    borderRadius: "8px",
    position: "relative",
    overflow: "hidden"
  },

  modalClose: {
    position: "absolute",
    top: "8px",
    right: "12px",
    cursor: "pointer",
    fontSize: "18px",
    zIndex: 10
  }
};
